export default "__VITE_ASSET___krhk_qc__"